import React from 'react';
import { Box, FormControl, MenuItem, Paper, Select, Tab, Tabs, Typography } from '@mui/material';
import SalesManagTab1 from './SalesManagTab1/SalesManagTab1';
import SalesManagTab2 from './SalesManagTab2';
import AnimationPage from '../../pages/AnimationPage';
import { useTranslation } from 'react-i18next';
const SalesManagement = () => {
  const [value, setValue] = React.useState('one');
  const { t } = useTranslation();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleTab = tab => {
    switch (tab) {
      case 'one':
        return <SalesManagTab1 setValue={setValue} />;
      case 'two':
        return <SalesManagTab2 setValue={setValue} />;
      default:
        return <SalesManagTab1 />;
    }
  };

  return (
    <AnimationPage>
      <div>
        <Box
          sx={{
            width: '100%',
            background: '#fff',
            borderRadius: '10px',
          }}>
          {/* <Tabs
            sx={{
              '& .MuiTab-root.MuiTab-textColorSecondary': {
                borderRadius: '12px',
                border: '1px solid #ddd',
                m: '10px 2px 0 0',
                minWidt: '100px',
                minHeight: '36px',
                fontSize: '13px',
                p: '0 10px',
              },
              '& .MuiTab-root.MuiTab-textColorSecondary.Mui-selected': {
                background: '#0F7F85',
                borderRadius: '12px',
                border: 'none',
                color: '#fff',
              },
              '& .MuiTabs-indicator': {
                display: 'none',
              },
            }}
            value={value}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example">
            <Tab value="one" label={t('Payment History')} />
            <Tab value="two" disabled label={t('Balance')} />
          </Tabs>
          <hr style={{ border: '1px solid #e1e1e1' }} />
          {handleTab(value)} */}
          <SalesManagTab1 setValue={setValue} />
        </Box>
      </div>
    </AnimationPage>
  );
};

export default SalesManagement;
